import React from 'react';
import LTSContextProvider from '../../context/LTSContext';
import { LTS_ROUTES_PATH } from '../../constants/LTSConstants';
import LTSLanding from '../LTSLanding/LTSLanding';
import LTSTrainNumber from '../LTSTrainNumber/LTSTrainNumber';
import LTSTrainDate from '../LTSTrainDate/LTSTrainDate';
import LTSTrainStation from '../LTSTrainStation/LTSTrainStation';
import Toast from '../../components/Toast/Toast.component';
import { getLtsSsrData } from '../../utils/LTSUtils';
import { getStaticPageLoadEvent } from '../../../../utils/omnitureUtils';
import { LTS_LANDING_INSTRUMENTATION_PAGE_NAME, LTS_LANDING_META_DATA } from '../../constants/SEOConstants';
import SEORating from '../../components/SEORating/SEORating.component';
import { APP_DOWNLOAD_BANNER } from '../../../../utils/RailsSEOConstants';

const LTSRoutesWrapper = (props: any) => {
  const {
    match: { path = '' }
  } = props;

  const renderComponent = () => {
    switch (path) {
      case LTS_ROUTES_PATH.landingPage:
        return <LTSLanding {...props} />;
      case LTS_ROUTES_PATH.trainNumberPage:
        return <LTSTrainNumber {...props} />;
      case LTS_ROUTES_PATH.datePickerPage:
        return <LTSTrainDate {...props} />;
      case LTS_ROUTES_PATH.stationPickerPage:
        return <LTSTrainStation {...props} />;
      default:
        return <LTSLanding {...props} />;
    }
  };

  return (
    <>
      <SEORating URL={APP_DOWNLOAD_BANNER.appLink} reviewCount={'1960035'} ratingValue={'4.6'} />
      <LTSContextProvider>
        {renderComponent()}
        <Toast />
      </LTSContextProvider>
    </>
  );
};

LTSRoutesWrapper.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: LTS_LANDING_META_DATA.template_name,
    meta_title: LTS_LANDING_META_DATA.title,
    meta_description: LTS_LANDING_META_DATA.description,
    meta_keywords: LTS_LANDING_META_DATA.keywords,
    analytics: getStaticPageLoadEvent(LTS_LANDING_INSTRUMENTATION_PAGE_NAME),
    footer_data: '',
    h1_title: LTS_LANDING_META_DATA.h1Title,
    banner_desktop: '',
    banner_mobile: '',
    sample_url: '',
    external_js: '',
    extra_info: '',
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.makemytrip.com/railways/`,
        displayString: `Train Ticket Booking`
      },
      {
        displayString: `Live Train Status`,
        redirectionUrl: `https://www.makemytrip.com/railways/liveStatus/`
      }
    ]
  };
  const pageData = getLtsSsrData(match?.path || LTS_ROUTES_PATH.landingPage);
  const pageUrl = pageData.canonicalUrl;
  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = pageData.cacheKey;

  return {
    pushToCache: pageData.pushToCache,
    cacheKey,
    pageType,
    pageUrl,
    ...finalResponse
  };
};

export default LTSRoutesWrapper;
